import { useEffect } from 'react';
// routing
import Routes from 'routes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import ThemeCustomization from 'themes';
import { useLogoutAllTabs } from 'hooks/useLogout';

// ==============================|| APP ||============================== //

function App() {
    const logoutTabs = useLogoutAllTabs();
    useEffect(() => logoutTabs(), []);


    return (
        <ThemeCustomization>
            <NavigationScroll>
                <Routes />
            </NavigationScroll>
        </ThemeCustomization>
    );
}

export default App;
